import React, { useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import payment_success from "../../../../assets/svgs/payment_success.svg";
import payment_failed from "../../../../assets/svgs/payment_failed.svg";
import Button from "../../Button/Button";
import { APP_NAME } from "../../../../lib/constants/globalConstant";
import { paymentModalStyles as styles } from "./paymentModal.tailwind.js";
import { PAYMENT_STATUS } from "../../../../lib/constants/globalConstant";
import { updatePayment } from "../../../../redux/slices/cartSlice.js";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../../../lib/constants/routeConstant.js";
import CubeLoader from "../../Loaders/CubeLoader/CubeLoader.jsx";



const errorData = {
  Heading: "Payment Failed!",
  SubHeading: "Something went wrong",
  Message: "The payment for your token purchase was not completed. Please try again or contact support if the issue persists.",
};

const PaymentModal = ({
  isOpen,
  onClose,
  status,
  updatePaymentInfo,
  seasonId,
  orderId
}) => {
  const navigate = useNavigate();
  const hasUpdatedPayment = useRef(false); // Ref to track if payment status has been updated
  const { updatingPayment, cartFetched, products, updatePaymentApiData } = useSelector((state) => state.cart);

  const successData = {
    Heading: "Thank you",
    SubHeading: `For supporting your ${APP_NAME}`,
    // Message: `A copy of your receipt has been sent to your email address ${updatePaymentApiData?.points}. Now Sit Back, Earn Points, Watch Games, and Get Exclusive Rewards!`,
    Message: `You have been awarded a bonus of ${updatePaymentApiData?.points} points for your token purchase`
  };

  const data = status === PAYMENT_STATUS.SUCCEDED ? successData : errorData;
  const image = status === PAYMENT_STATUS.SUCCEDED ? payment_success : payment_failed;

  useEffect(() => {
    // API call to update payment status when modal opens
    if (isOpen && !hasUpdatedPayment.current && cartFetched && orderId && seasonId) {      
      hasUpdatedPayment.current = true; // Set ref to true to prevent additional calls

      // Data
      const data = {
        paymentStatus: status,
        orderId: orderId,
        seasonId: seasonId,
      };
      
      // API call to update payment status
      updatePaymentInfo(data);
    }
  }, [isOpen, status, updatePaymentInfo, cartFetched, orderId, seasonId]);

  useEffect(() => {
    if(cartFetched && products?.length === 0 && !hasUpdatedPayment.current){
      navigate(routeConstant.MY_ACCOUNT_PAGE, { replace: true })
    }
  }, [cartFetched, products]);

  useEffect(() => {
    if (isOpen) {
      // Remove query parameters once the modal is open
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [isOpen]);

  return (
    <Modal
      open={isOpen} // Use the isOpen prop to control the modal's visibility
      onClose={() => {}} // Prevent closing when clicking outside
      disableAutoFocus
    >
      {updatingPayment || !hasUpdatedPayment.current ? (
        <div className="w-full h-full flex items-center justify-center">
          <CubeLoader />
        </div>
      ) : (
        <div className={styles.container}>
          {/* close button */}
          <button onClick={onClose}>
            <CloseIcon
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
                fontSize: "16px",
              }}
            />
          </button>

          {/* main-content */}
          <div className={styles.innerContainer}>
            {/* center-icon */}
            <div
              className={`${styles.doneIcon} ${
                status === PAYMENT_STATUS.SUCCEDED ? "bg-[#E2FEEE]" : " w-[100%]"
              } `}
            >
              <img src={image} alt="Payment Message" className={`${ status === PAYMENT_STATUS.SUCCEDED ? "max-[30px]" : "max-w-[50px] w-[100%]"}`}/>
            </div>

            {/* texts */}
            <div
              className={`${
                status === PAYMENT_STATUS.SUCCEDED
                  ? styles.thankYouText
                  : styles.thankYouTextError
              }`}
            >
              {data.Heading}
              <div
                className={`${
                  status === PAYMENT_STATUS.SUCCEDED
                    ? styles.thankYouMessage
                    : styles.thankYouMessageError
                }`}
              >
                {data.SubHeading}
              </div>
            </div>
            <div className={styles.message}>{data.Message}</div>

            {/* close button */}
            <Button variant="primary" onClick={onClose}>
            {status === PAYMENT_STATUS.SUCCEDED ? "Account Home" : "Retry Payment"}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updatePaymentInfo: (data) => dispatch(updatePayment(data)),
});

export default connect(null, mapDispatchToProps)(PaymentModal);
